import React from "react";
import { Route, Switch } from "react-router-dom";

// components
import Orders360 from "../components/Dashboard/Main/Main.container";

// styled components
import { ExternalWrapper } from "./routes.styles";

export default (props: any) => {
  return (
    <ExternalWrapper className="container-fluid">
      <Switch>
        <Route exact path="/" component={Orders360} />
        <Route path="*" component={Orders360} />
      </Switch>
    </ExternalWrapper>
  );
};
